export function mergeChronological<T>(
  current: T[],
  incoming: T[],
  timestamp: (value: T) => string,
): T[] {
  const values = new Map<string, T>();
  for (const value of current) values.set(timestamp(value), value);
  for (const value of incoming) values.set(timestamp(value), value);
  return [...values.values()].sort(
    (left, right) =>
      Date.parse(timestamp(left)) - Date.parse(timestamp(right)),
  );
}

export function prependedItemCount<T>(
  previousFirstTimestamp: string | null,
  values: T[],
  timestamp: (value: T) => string,
): number {
  if (!previousFirstTimestamp) return 0;
  return values.findIndex(
    (value) => timestamp(value) === previousFirstTimestamp,
  );
}
